import { render, staticRenderFns } from "./HotelModal.vue?vue&type=template&id=616dd6ba"
import script from "./HotelModal.vue?vue&type=script&lang=js"
export * from "./HotelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports